function setupFooterToggle() {
  if (window.innerWidth > 749) return;

  document.querySelectorAll('.footer-block--menu').forEach((block) => {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content || block.dataset.toggleApplied === 'true') return;
    block.dataset.toggleApplied = 'true';

    // Add icon if not added
    if (!heading.querySelector('.toggle-icon-wrapper')) {
      const iconWrapper = document.createElement('span');
      iconWrapper.classList.add('toggle-icon-wrapper');
      iconWrapper.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.656333C10 0.83839 9.94154 0.987296 9.82195 1.11291L5.49627 5.75932C5.41758 5.84195 5.33707 5.90212 5.2566 5.93968C5.1774 5.97666 5.09025 5.99682 4.9935 6C4.90542 5.99989 4.82059 5.98177 4.7434 5.94574C4.66431 5.90882 4.58458 5.84762 4.50483 5.7605L0.179532 1.11448C0.0584621 0.987296 0 0.83839 0 0.656333C0 0.530468 0.0276203 0.419913 0.0825768 0.321628C0.1382 0.22215 0.211969 0.143892 0.305674 0.0845271C0.394948 0.0279683 0.493752 0 0.606613 0C0.76983 0 0.913223 0.0656133 1.0467 0.205814L4.8559 4.3218H5.1441L8.95516 0.203826C9.08678 0.0656133 9.23017 0 9.39339 0C9.50215 0 9.59906 0.0278271 9.68856 0.0845271C9.78285 0.144265 9.858 0.223194 9.91562 0.323524C9.97181 0.421386 10 0.531237 10 0.656333Z" fill="#141414"/>
        </svg>
      `;
      heading.appendChild(iconWrapper);
    }

    heading.addEventListener('click', () => {
      const isOpen = block.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px'; // trigger reflow
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
        block.classList.remove('is-open');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        block.classList.add('is-open');

        // Optional: reset to auto after transition
        content.addEventListener('transitionend', function handler() {
          if (block.classList.contains('is-open')) {
            content.style.maxHeight = 'none';
          }
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', setupFooterToggle);

// Reset and re-init on resize
window.addEventListener('resize', () => {
  document.querySelectorAll('.footer-block--menu').forEach((block) => {
    const content = block.querySelector('.footer-block__details-content');
    const icon = block.querySelector('.toggle-icon-wrapper');

    if (window.innerWidth > 768) {
      block.classList.remove('is-open');
      block.dataset.toggleApplied = '';
      if (content) {
        content.style.maxHeight = '';
        content.style.overflow = '';
      }
      if (icon) icon.remove();
    } else {
      setupFooterToggle();
    }
  });
});
